import React from "react";

const UTCtime = () => {
  const [time, setTime] = React.useState(new Date());
  React.useEffect(() => {
    setInterval(() => {
      setTime(new Date());
    }, 1000);
  }, []);
  return (
    <p className="smallSubInfo has-text-yellow">
      * UTC Time : {time.toUTCString().split(",")[1]}
    </p>
  );
};

export default UTCtime;